import { useSearchParams } from "react-router-dom"

function useQueryParams() {
    const [query, setSearchParams] = useSearchParams();

    const setQueryParams = (params: any) => {
        const newQuery = new URLSearchParams(query);

        Object.keys(params).forEach((key) => {
            if (params[key] !== undefined && params[key] !== null) {
                newQuery.set(key, params[key]);
            } else {
                newQuery.delete(key);
            }
        });
        console.log('newQuery', newQuery)

        setSearchParams(newQuery)
    }

    return { query, setQueryParams };
}

export default useQueryParams;